// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__Rly3j","loading":"skeleton_loading__ab3O7"};